const commonCode = {
    NOTI_TYPE: 2, //통보방법
    EVT_LEVEL: 6, //이벤트 위험도
    CLCTR_TYPE: 10, //수집프로그램 유형
    PROTO_TYPE: 15, //프로토콜 유형
    DATA_TYPE: 20, //수집항목 유형
    TIME_UNIT: 24, //시간단위
    IF_SYSTEM: 31, //인터페이스 시스템
    MON_TYPE: 34, //모니터링대상 유형
    PROG_MTP: 40, //수집프로그램 맵핑 대상
    GROUP_TYPE: 43, //그룹 유형
    LANGUAGE: 48, //언어
    COMPARE_TYPE: 51, //비교 유형
    FUNCTION_TYPE: 63, //함수 유형
    API_AUTH_TYPE: 65, //API 권한
    API_METHOD: 68, //API 유형
    CLCTR_ITEM_TYPE: 73, //수집프로그램 아이템 유형
    MODULE_TYPE: 77, //모듈 유형
    MON_ITEM_LEVEL: 84, //모니터링대상 항목 레벨
    MON_STATUS: 88, //모니터링대상 상태
    PERIOD_TYPE: 92, //기간 유형
    REPEAT_CONDITION: 100, //반복 주기
    REPEAT_SETTING: 104, //반복 설정
    USERLOCK_STATE: 108, //사용자잠금 상태
    USER_STATE: 111, //사용자 상태
    WEEKS: 114, //주차
    WEEK_UNIT: 121, //요일
    WORKING_DAY: 129, //근무일
    COMPARE_TYPE_TEXT: 137, //비교 유형
    KUBERNETES_SERVICE_UNIT: 142, //Kubernetes 서비스 단위
    STATISTIC_DURATION: 151, //통계 기간
    STATISTIC_DURATION_TYPE: 158, //통계 타입
    RULE_TYPE: 163, //이벤트 룰 타입
    TEST: 166, //TEST2
    getByCode(codeSq) {
        return window.commonCode.filter((item) => item.parentCodeSq == codeSq);
    },
    getById(codeId) {
        return window.commonCode.filter((item) => item.codeNmLoc == codeId);
        //return this.getByCode(this[codeId]);
    },
    get(param) {
        let result = [];
        if (typeof param == 'number') {
            result = this.getByCode(param);
        } else {
            result = this.getById(param);
        }
        return this.convertLegoArr(result);
    },
    values(param, firstItem = {text: '전체', value: ''}) {
        let legoArr = this.get(param);
        legoArr.unshift(firstItem);
        return legoArr;
    },
    convertLegoArr(arr) {
        let legoObj = [];
        for (let i in arr) {
            let tmp = {};
            tmp.text = arr[i].codeNmLoc;
            tmp.value = arr[i].codeId;
            legoObj.push(tmp);
        }
        return legoObj;
    }
};
export default {
    install(app) {
        app.config.globalProperties.$code = commonCode;
    }
};
